<template lang="pug">
.flex
  BriqMultiselect(
    label="Select product"
    data-test-id="add-product-multiselect"
    :options="sortedProducts"
    display="NameInternal"
    v-model="product"
    track-by="Key"
    required="required"
    :bindObject="true"
    :disabled="pending"
    :pending="pending"
    )
  BriqButton.add-product-btn(
    wide
    variant="main"
    :class="{pending}"
    :disabled="!product || pending"
    data-test-id="add-product-button"
    @click="addProduct"
    ) Add product
</template>

<script>
import sortProducts from '@v/util/sortProducts.js'
import { max, map, prop, pipe, filter } from 'ramda'
import DealProductType from '@v/bookings/edit/models/DealProductType.js'

export default {
  name: 'AddProduct',
  props: {
    deal: { type: Object, required: true },
    products: { type: Array, required: true },
    pending: Boolean,
  },
  computed: {
    sortedProducts() {
      return pipe(filter(prop('Enabled')), sortProducts)(this.products)
    },
  },
  data() {
    return {
      product: null,
    }
  },
  methods: {
    addProduct() {
      const productToBeAdded = {
        Key: null,
        ProductKey: this.product.Key,
        ProductGroupKey: this.deal.Key,
        ProductNameInternal: this.product.NameInternal,
        ProductNeedsToBeScheduled: this.product.NeedsToBeScheduled,
        BasePrice: this.product.Price,
        PriceType: this.product.PriceType,
        PriceIncludesTax: this.product.PriceIncludesTax,
        ProductQuantity: 1,
        PriceOffset: null,
        ProgramOrder: max(map(prop('ProgramOrder'))(this.deal.Products)) + 1,
        Type: DealProductType.DealProduct, // Default type of deal product
      }

      this.deal.Products.push(productToBeAdded)
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.flex
  margin-top space-S
  justify-content center

  > *
    min-width 80%
    margin space-XXS

  .add-product-btn
    align-self flex-end
    margin-bottom space-XXS
</style>
